import {
  VISIT_NOTE_CATEGORIES,
  type VisitNoteCategoryDefinition,
} from '@seen/core/models/visitNoteCategory'
import { Badge } from '@seen/ui'
import { IconLock } from '@tabler/icons-react'
import type { ColumnDef } from '@tanstack/react-table'
import { type JSX, useMemo } from 'react'
import { DataTable } from '#src/components/core/data-table/DataTable.tsx'

// Built-in visit-note categories rendered on the Note Labels page. They mirror
// the custom-label row look (color dot + name) so they read as the same kind of
// thing, but carry a "System" tag and expose no click/edit/delete affordances —
// the DataTable stays read-only because no onRowClick/deleteRowProps are passed.
export function SystemNoteLabels(): JSX.Element {
  const columns: ColumnDef<VisitNoteCategoryDefinition>[] = useMemo(
    () => [
      {
        accessorKey: 'display',
        header: 'Name',
        cell: ({ row }) => (
          <div className="flex items-center gap-1.5">
            <div className="flex size-3.5 shrink-0 items-center justify-center">
              <div
                style={{ backgroundColor: row.original.color }}
                className="size-2.25 rounded-full"
              />
            </div>
            {row.original.display}
          </div>
        ),
      },
      {
        id: 'system',
        cell: () => (
          <div className="flex justify-end">
            <Badge variant="secondary" className="gap-1">
              <IconLock className="size-3" />
              System
            </Badge>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <section className="flex flex-col gap-2">
      <div className="flex flex-col gap-0.5">
        <h2 className="text-sm font-medium">System labels</h2>
        <p className="text-xs text-muted-foreground">
          Built-in categories Seen provides. These are read-only — they can't be
          edited or deleted.
        </p>
      </div>
      <DataTable columns={columns} data={VISIT_NOTE_CATEGORIES} />
    </section>
  )
}
